import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass } from '../../nodeCatalog'
import { enrichmentNodeSummary } from '../../enrichmentConfig'

const TYPE = 'enrichContacts'
const Icon = nodeIcon(TYPE)

const EnrichContactsNode: React.FC<NodeProps> = ({ data, selected }) => {
  const config = data.enrich_contacts_config

  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <Handle
        type="target"
        position={Position.Top}
        className={nodeHandleClass(TYPE)}
      />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Enrich Contacts</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'Enrich'}</p>
        </div>
      </div>
      {/* Provider count leads: the card used to summarise only the block
          count, so selecting or deselecting a provider changed nothing here
          (AB#21978). See enrichmentConfig.ts for the config shapes. */}
      <p className="mt-1 text-xs text-muted-foreground pl-10">
        {enrichmentNodeSummary(config)}
      </p>
      <Handle
        type="source"
        position={Position.Bottom}
        className={nodeHandleClass(TYPE)}
      />
    </div>
  )
}

export default memo(EnrichContactsNode)
